import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { HealthArticle, Tag } from '@app/_models/health';
import { Router } from '@angular/router';
import { HealthService } from '@app/services/health/health.service';
import * as moment from 'moment';
import { Dictionary } from '@app/_models/shared.model';
import { MatPaginator } from '@angular/material';
import { tap } from 'rxjs/operators';
import { HealthDataSource } from '@app/services/health/health.datasource';
@Component({
  selector: 'health',
  templateUrl: './health-list.component.html',
  styleUrls: ['./health-list.component.scss'],
})
export class HealthComponent implements OnInit, AfterViewInit {
  constructor(private _router: Router, private _healthService: HealthService) { }
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  healthList: HealthDataSource;
  displayedColumns = ['title', 'tags', 'status', 'date', 'options'];
  totalRecords: number;
  tags: Tag[] = [];
  states: Dictionary[] = [
    {
      name: 'Todos',
      value: -1,
    },
    {
      name: 'Borrador',
      value: 0,
    },
    {
      name: 'Publicado',
      value: 1,
    },
  ];
  selectedState: number = this.states[0].value;

  ngOnInit(): void {
    this.healthList = new HealthDataSource(this._healthService);
    this.healthList.loadHealthArticles().then((total: number) => this.totalRecords = total);
    this._healthService.getTags().subscribe((tags: Tag[]) => {
      this.tags = tags;
    });
  }

  ngAfterViewInit(): void {
    this.paginator.page
      .pipe(
        tap(() => this.healthList.loadHealthArticles(this.paginator.pageIndex, this.paginator.pageSize, this.selectedState))
      )
      .subscribe();
  }

  loadHealthArticlesListByStatus(): void {
    this.healthList.loadHealthArticles(this.paginator.pageIndex, this.paginator.pageSize, this.selectedState).then((total: number) => this.totalRecords = total);
  }

  addNewHealthItem(): void {
    this._router.navigate(['health/create']);
  }
  editHealthItem(item: HealthArticle): void {
    this._router.navigate([`health/${item.id}`]);
  }

  getTagDetails(tagsIds: number[]) {
    const tagsValues: string[] = [];
    tagsIds.forEach((tagId: number) => {
      const tag = this.tags.find(e => {
        return e.id === tagId;
      });
      if (tag) {
        tagsValues.push(tag.name);
      }
    });
    return tagsValues.join(', ');
  }

  getHealthArticleDate(date: moment.Moment) {
    return moment(date, moment.ISO_8601).format('DD/MM/YYYY HH:mm');
  }

  getTagStatus(statusId: number) {
    const status = this.states.find(state => {
      return state.value === statusId;
    });
    return status.name;
  }

  goToHealthDetail(id: number) {
    this._router.navigate([`/health/${id}`]);
  }
}
